var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayersLightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838F",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15.5 2 3 8l12.5 6L28 8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#77838F",
  d: "M28.754 15.006a1 1 0 0 1 0 1.814l-12.5 5.8a1 1 0 0 1-.842 0l-12.5-5.8a1 1 0 0 1 0-1.814l8.665-4.022 2.35 1.115-8.218 3.814 10.124 4.697 10.123-4.697-8.219-3.814 2.35-1.115z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#77838F",
  d: "M14.02 20.186 5.71 24.043l10.124 4.697 10.123-4.697-8.13-3.773 2.162-1.202 8.766 4.068a1 1 0 0 1 0 1.814l-12.5 5.8a1 1 0 0 1-.842 0l-12.5-5.8a1 1 0 0 1 0-1.814l8.946-4.152z"
})));
export default SvgLayersLightIcon;